<template>
  <div class="inicio ">
    <!-- <div class="header-slider"></div>
    <agile :navButtons="false" :dots="false" autoplay fade :autoplaySpeed="10000">
                <div class="slide">
                    <a href="https://notin.es" target="_blank"><img class="w100" src="img/baner-noticias.jpg"/></a>
                </div>
                <div class="slide">
                    <a href="/notariavirtual" target="_blank"><img class="w100" src="img/baner-noticias-2.jpg"/></a>
                </div>
    </agile>   -->
    <section class="section-shaped my-0">
      <div class="shape shape-style-2 shape-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0 py-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3  text-white">
                Productividad y rentabilidad de la Notaría con la tecnología fácil de NOTIN
                <!-- <span>Ecosistema NOTIN</span> -->
              </h1>
              <!-- <p class="lead  text-white">
              AUMENTA LA EFICIENCIA DE LA NOTARÍA CON LA TECNOLOGÍA NOTIN.
              </p> -->
              <p class="lead  text-white">
                Somos el único fabricante que aplica metodología ágil al servicio de la Notaría. Nuestro ecosistema digital esta desarrollado conjuntamente con Notarios para mejorar la gestión integral de las Notarías mediante el desarrollo de tecnología de fácil uso y en continua evolución para atender las cambiantes demandas y necesidades del sector notarial.
              </p>
              <div class="btn-wrapper">
                <!-- <p class="lead text-white">
                  Integración completa entre nuestros productos y las distintas plataformas necesarias para la gestión notarial.
                </p> -->
                <router-link
                  
                  to="/productos"
                  class="btn btn-white btn-icon mb-3 mb-sm-0"
                >
                  <i style="color: red" class="fa fa-rocket"></i>
                  <span class="btn-inner--text"
                    >Más sobre NOTIN</span
                  >
                </router-link>
              </div>
            </div>
            <div class="col-lg-6 text-center">
              <a href="https:/notin.es/portal">
                <img class="w100 img-shadow mt-2" src="img/inicio__.jpg"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div  class="parallax-container mt--100">
      <parallax fixed >
        <img :src="'img/mockup-nmp.jpg'"/>
      </parallax>
    </div>
    <section class="section section-lg bg-white mt--200">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <img class="img-shadow" src="img/brand/white.png"/>
            <h2 class="display-3">
              Notaria Virtual NOTIN
              <span class="text-success">Como, cuando, y donde quiera</span>
            </h2>
            <p class="lead">
              La libertad llega al mundo de las notarías, con nuestra aplicación multiplataforma. Tanto el personal de la notaría como los clientes, podrán acceder a los datos de su notaría, y gestionar operaciones.
            </p>

            <div class="btn-wrapper">
              <router-link
                to="/productos"
                class="btn btn-warning mb-3 mb-sm-0"
                >Funcionalidades</router-link
              >
              <a
                v-scroll-to="'#contacto'"
                
                class="btn btn-primary mb-3 mb-sm-0 text-white"
                >Solicitar DEMO</a
              >
            </div>
            <div class="text-center">
              <h4 class="display-4 mb-5 mt-5">
                Disponible en cualquier plataforma
              </h4>
              <div class="row justify-content-center">
                <div class="col-lg-2 col-4">
                  <a
                    href="#"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title=""
                  >
                    <i class="fa fa-windows fa-3x"/>
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="#"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title=""
                  >
                    <i class="fa fa-apple fa-3x"/>
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="#"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title=""
                  >
                    <i class="fa fa-android fa-3x"/>
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="#"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title=""
                  >
                    <i class="fa fa-linux fa-3x"/>
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="#"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title=""
                  >
                    <i class="fa fa-chrome fa-3x"/>
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="#"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title=""
                  >
                    <i class="fa fa-edge fa-3x"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <SliderTestimonios/>
    <section class="section bg-white">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img
                v-lazy="'img/dev-team.jpg'"
                class="card-img-top"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Nuestro Equipo
                </h4>
                <p class="lead text-italic text-white">
                  Nuestra razón de ser es la de contribuir a la mejora del servicio que prestan las notarías y aumentar su productividad a través de la digitalización fácil, tanto en el desarrollo de los servicios que ofrecen como en la propia gestión del despacho notarial.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon
                name="fa fa-users"
                class="mb-5"
                size="lg"
                type="warning"
                shadow
                rounded
              ></icon>

              <h3>Sobre Nosotros</h3>
              <p class="">
                <strong>Trabajamos para generar una reducción importante en procesos administrativos colaterales que actualmente ocupan irremediablemente el tiempo de los oficiales, al reducir drásticamente el tiempo de su procesamiento y permitir la redistribución inteligente de tareas entre compañeros, liberando así a nuestros primeros espadas para que dispongan de tiempo suficiente para tratar profesionalmente a clientes y realizar el resto de labores comerciales que contribuirá a generar negocio a la Notaría.</strong>
              </p>
              <p>
                <strong>Nuestra experiencia y el estar en contacto permanente con las notarías nos permiten enfocar todas las mejoras aplicadas a nuestro producto y su adecuado manejo del personal están dirigidas a cumplir con un objetivo principal: LA MEJORA DEL SERVICIO GLOBAL de la notaría a través de LA UTILIZACIÓN DE LA TECNOLOGÍA, de una manera fácil para optimizar el trabajo interno mejorando el servicio que éstas prestan a sus clientes.</strong>
              </p>
              <router-link target="_blank" to="/nosotros" class="font-weight-bold text-warning mt-5">
              Sobre Nosotros
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Numeros/>
  </div>
</template>
<script>
import Cookies from "../utils/Cookies";
import router from "../router.js";
export default {
  name: "Inicio",
  components: {
    SliderTestimonios: () => import('../components/SliderTestimonios.vue'),
    Numeros: () => import('../components/Numeros.vue'),
//    ParallaxImage: () => import("../components/ParallaxImage.vue"),
    Parallax: () => import('vue-parallaxy'),
  },
  data: () => ({
   
  }),
  methods: {
   
  }
};
</script>
<style>
.form-errors {
  color: red;
}
div.input-error {
  border: 1px solid red;
}
</style>
